module.exports = __webpack_public_path__ + "img/currency.01adda93.svg";